/* By Beth: total + dollar saving under each Upnova "Buy more and SAVE" tier.
   Reads the price and quantity Upnova renders, so it always matches the app. */
(function () {
  function money(n) {
    var r = Math.round(n * 100) / 100;
    return '$' + (r % 1 === 0 ? r.toFixed(0) : r.toFixed(2));
  }
  function num(text) {
    var m = String(text || '').replace(/,/g, '').match(/\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }
  function tierPrice(tier) {
    var el = tier.querySelector('[part="tier-price"]');
    if (!el) return NaN;
    return num(el.firstChild ? el.firstChild.textContent : el.textContent);
  }
  function tierQty(tier) {
    var el = tier.querySelector('[part="tier-quantity"]');
    return el ? num(el.textContent) : NaN;
  }
  function enhance(root) {
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[part="tier-option"]'));
    if (!tiers.length) return;

    var base = NaN;
    tiers.forEach(function (t) { if (isNaN(base) && tierQty(t) === 1) base = tierPrice(t); });
    if (isNaN(base)) base = tierPrice(tiers[0]);

    tiers.forEach(function (tier) {
      var qtyEl = tier.querySelector('[part="tier-quantity"]');
      var p = tierPrice(tier);
      var q = tierQty(tier);
      var line = tier.querySelector('.bb-tier-savings');
      if (!qtyEl || isNaN(p) || isNaN(q) || q < 1) { if (line) line.remove(); return; }

      var total = money(p * q) + ' total';
      var saving = (base - p) * q;
      var saveText = saving >= 0.5 ? 'Save ' + money(saving) : '';

      // Hide Upnova's "SAVE X%" tag on a multi-unit tile that costs the same per unit as
      // a single unit (e.g. when Subscribe & save is selected), so the page never claims
      // a saving the customer doesn't get.
      var badge = tier.querySelector('[part="discount-badge"]');
      if (badge) badge.style.display = (q > 1 && !saveText) ? 'none' : '';
      var key = total + '|' + saveText;

      if (!line) {
        line = document.createElement('div');
        line.className = 'bb-tier-savings';
        qtyEl.insertAdjacentElement('afterend', line);
      }
      if (line.getAttribute('data-key') === key) return;
      line.setAttribute('data-key', key);
      line.innerHTML = '';
      var a = document.createElement('span');
      a.className = 'bb-tier-total';
      a.textContent = total;
      line.appendChild(a);
      // Single-unit tile gets an invisible placeholder so every tile keeps the same height.
      var b = document.createElement('span');
      b.className = 'bb-tier-save';
      b.textContent = saveText || 'Save $0';
      if (!saveText) { b.style.visibility = 'hidden'; b.setAttribute('aria-hidden', 'true'); }
      line.appendChild(b);
    });

    if (!root.querySelector('#bb-tier-savings-style')) {
      var s = document.createElement('style');
      s.id = 'bb-tier-savings-style';
      s.textContent =
        '.bb-tier-savings{display:flex;flex-direction:column;align-items:center;gap:1px;margin-top:6px;line-height:1.3}' +
        '.bb-tier-total,.bb-tier-save{white-space:nowrap;font-size:12px}' +
        '.bb-tier-total{opacity:.8}' +
        '.bb-tier-save{font-weight:700;color:#2f6f78}' +
        '@media (max-width:600px){.bb-tier-total,.bb-tier-save{font-size:10.5px}}';
      root.appendChild(s);
    }
  }
  function attach(widget) {
    if (!widget.shadowRoot || widget.__bbSavings) return;
    widget.__bbSavings = true;
    var root = widget.shadowRoot;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; enhance(root); });
    }).observe(root, { childList: true, subtree: true, characterData: true });
    enhance(root);
  }
  function scan() {
    var widgets = document.querySelectorAll('upnova-widget[id^="upez-product-volume"]');
    for (var i = 0; i < widgets.length; i++) attach(widgets[i]);
  }
  function refresh() {
    scan();
    var widgets = document.querySelectorAll('upnova-widget[id^="upez-product-volume"]');
    for (var i = 0; i < widgets.length; i++) if (widgets[i].shadowRoot) enhance(widgets[i].shadowRoot);
  }
  refresh();
  // Re-check regularly so the figures follow subscription/one-time and variant changes.
  // Cheap: it only rewrites a tile when its numbers change.
  setInterval(refresh, 800);
  document.addEventListener('change', function () { setTimeout(refresh, 50); }, true);
  document.addEventListener('shopify:section:load', refresh);
})();

/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function() {
  // Add custom code below this line
  const editorMobileTitleQuery = window.matchMedia('(max-width: 749px)');

  function syncEditorProductTitle(section) {
    const destination = section.querySelector('.product__mobile-title');
    const ratingDestination = section.querySelector('[data-mobile-rating-destination]');
    const placeholder = section.querySelector('[data-product-title-placeholder]');
    const title = section.querySelector('.product__content .product__head, .product__mobile-title .product__head');

    if (!destination || !ratingDestination || !placeholder || !title) return;

    if (editorMobileTitleQuery.matches) {
      destination.style.setProperty('display', 'block', 'important');
      destination.style.setProperty('position', 'static', 'important');
      destination.style.setProperty('width', 'auto', 'important');
      destination.style.setProperty('height', 'auto', 'important');
      destination.style.setProperty('overflow', 'visible', 'important');
      destination.style.setProperty('visibility', 'visible', 'important');
      destination.style.setProperty('pointer-events', 'auto', 'important');
      destination.insertBefore(title, ratingDestination);
    } else if (placeholder.parentNode) {
      destination.style.setProperty('display', 'none', 'important');
      destination.style.setProperty('position', 'absolute', 'important');
      destination.style.setProperty('width', '0', 'important');
      destination.style.setProperty('height', '0', 'important');
      destination.style.setProperty('overflow', 'hidden', 'important');
      destination.style.setProperty('visibility', 'hidden', 'important');
      destination.style.setProperty('pointer-events', 'none', 'important');
      placeholder.parentNode.insertBefore(title, placeholder.nextSibling);
    }
  }

  function syncEditorProductTitles(root = document) {
    if (root.matches?.('[data-editor-mobile-title]')) {
      syncEditorProductTitle(root);
    }

    root.querySelectorAll?.('[data-editor-mobile-title]').forEach(syncEditorProductTitle);
  }

  syncEditorProductTitles();

  document.addEventListener('shopify:section:load', (event) => {
    syncEditorProductTitles(event.target);
  });

  if (editorMobileTitleQuery.addEventListener) {
    editorMobileTitleQuery.addEventListener('change', () => syncEditorProductTitles());
  } else {
    editorMobileTitleQuery.addListener(() => syncEditorProductTitles());
  }

  let addbutton = document.getElementById("cart__checkout");
    addbutton.addEventListener("click", function() {
    let upsellproduct = document.getElementById("ap-quick-add-product");
    let clone = upsellproduct.cloneNode(true);
    document.getElementById("checkout-upsell-append").appendChild(clone);
  });


  // avoid leaking your variables into the global scope.
})();



